import API from 'src/utils/api';

const { createContext, useContext, useRef, useState, useEffect } = require('react');

const DEFAULT_VALUES = { email: '', firstName: '', lastName: '' };

const UserContext = createContext(DEFAULT_VALUES);

export const useUserProfile = () => {
    return useContext(UserContext);
};

export const UserProfileProvider = ({ children }) => {
    // Refs
    const fetchingProfile = useRef(false);
    // State
    const [email, setEmail] = useState(DEFAULT_VALUES.email);
    const [firstName, setFirstName] = useState(DEFAULT_VALUES.firstName);
    const [lastName, setLastName] = useState(DEFAULT_VALUES.lastName);

    useEffect(() => {
        if (fetchingProfile.current) return; // make sure to fetch data only at first render
        const fetchProfile = async () => {
            fetchingProfile.current = true;
            try {
                const response = await API.get('/user/profile');

                setFirstName(response.data.user.firstName);
                setLastName(response.data.user.lastName);
                setEmail(response.data.user.email);

                fetchingProfile.current = false;
            } catch (error) {
                fetchingProfile.current = false;
            }
        };

        fetchProfile();
    }, []);

    return <UserContext.Provider value={{ email, firstName, lastName }}>{children}</UserContext.Provider>;
};
